// components/cells/CellPopoverInfo.tsx
import {
  Box,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import React, { useState } from "react";
import { DateTime } from "luxon";

interface CellPopoverInfoProps {
  params: any;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const CellPopoverInfo = ({ params, children, onClick }: CellPopoverInfoProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (onClick) {
      onClick(e); // call external logic if needed
    }
    setAnchorEl(e.currentTarget); // show popover
  };

  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? "cell-popover" : undefined;

  // const formattedDate = params?.row?.updated_at
  // ? DateTime.fromISO(params.row.updated_at).toFormat("dd LLL yyyy")
  // : "Unknown";
  const formattedDate = DateTime.now().toFormat("dd LLL yyyy");

  return (
    <>
      <Box component="span" display="flex" alignItems="center" gap={0.5}>
        <Typography variant="body2" noWrap>
          {children}
        </Typography>
        <IconButton
          aria-describedby={id}
          onClick={handleClick}
          aria-label="delete"
        >
          <InfoIcon />
        </IconButton>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          sx: { px: 2, py: 1 },
        }}
      >
        <Typography variant="body2">
          Last synced on {formattedDate}
        </Typography>
      </Popover>
    </>
  );
};

export default CellPopoverInfo;
